import React from 'react'
import { useNavigationContext } from '../NavigationContext'
import styles from './styles.css'

const NavigationVeil: React.FC = () => {
  const navContext = useNavigationContext()

  return (
    <div
      className={styles.veil}
      style={{
        visibility: navContext?.isVeilVisible || navContext?.isSearchVisible ? 'visible' : 'hidden',
        opacity: navContext?.isVeilVisible || navContext?.isSearchVisible ? 100 : 0
      }}
    />
  )
}

export default NavigationVeil
